// Meat data with normalized structure
const buildYourOwnBasePrice = 15.99

const meats = [
  {
    id: 1,
    name: 'Corned Beef',
    description: 'House made corned beef',
    tag: 'Customer Favorite',
    base_price: buildYourOwnBasePrice,
    is_featured: true,
    category: ['popular', 'beef'],
    icon: 'drumstick'
  },
  {
    id: 2,
    name: 'Pastrami',
    description: 'Spiced and smoked pastrami',
    tag: 'House Specialty',
    base_price: buildYourOwnBasePrice,
    is_featured: true,
    category: ['popular', 'beef'],
    icon: 'drumstick'
  },
  {
    id: 3,
    name: 'White Turkey Breast',
    description: 'Roasted white meat turkey',
    base_price: buildYourOwnBasePrice,
    is_featured: false,
    category: ['turkey'],
    icon: 'drumstick'
  },
  {
    id: 4,
    name: 'Smoked Turkey Breast',
    description: 'Hickory smoked turkey breast',
    base_price: buildYourOwnBasePrice,
    is_featured: false,
    category: ['turkey'],
    icon: 'drumstick'
  },
  {
    id: 5,
    name: 'Turkey Pastrami',
    description: 'Turkey pastrami',
    base_price: buildYourOwnBasePrice,
    is_featured: false,
    category: ['turkey'],
    icon: 'drumstick'
  },
  {
    id: 6,
    name: 'Brisket Roast Beef',
    description: 'Slow-roasted beef brisket',
    base_price: buildYourOwnBasePrice,
    is_featured: false,
    category: ['beef'],
    icon: 'drumstick'
  },
  {
    id: 7,
    name: 'Rare Roast Beef',
    description: 'Rare roast beef',
    base_price: buildYourOwnBasePrice,
    is_featured: false,
    category: ['beef'],
    icon: 'drumstick',
    needs_warning: true
  },
  {
    id: 8,
    name: 'Tuna Salad',
    description: 'House-made tuna salad',
    base_price: buildYourOwnBasePrice,
    is_featured: false,
    category: ['popular', 'salads'],
    icon: 'sandwich'
  },
  {
    id: 9,
    name: 'Chicken Salad',
    description: 'Fresh chicken salad',
    base_price: buildYourOwnBasePrice,
    is_featured: false,
    category: ['salads'],
    icon: 'sandwich'
  },
  {
    id: 10,
    name: 'Egg Salad',
    description: 'Fresh egg salad',
    base_price: 7.99,
    is_featured: false,
    category: ['salads'],
    icon: 'egg'
  },
  {
    id: 11,
    name: 'Chopped Liver',
    description: 'Traditional chopped liver',
    base_price: buildYourOwnBasePrice,
    is_featured: false,
    category: ['salads'],
    icon: 'sandwich'
  },
  {
    id: 12,
    name: 'Veggie Liver',
    description: 'Vegetarian liver',
    base_price: buildYourOwnBasePrice,
    is_featured: false,
    category: ['vegetarian'],
    icon: 'leaf'
  },
  {
    id: 13,
    name: 'Hard Salami',
    description: 'Hard deli salami',
    base_price: 16.99,
    is_featured: false,
    category: ['beef'],
    icon: 'bacon'
  },
  {
    id: 14,
    name: 'Medium Salami',
    description: 'Medium deli salami',
    base_price: 16.49,
    is_featured: false,
    category: ['beef'],
    icon: 'bacon'
  },
  {
    id: 15,
    name: 'Soft Salami',
    description: 'Soft deli salami',
    base_price: buildYourOwnBasePrice,
    is_featured: false,
    category: ['beef'],
    icon: 'bacon'
  },
  {
    id: 16,
    name: 'Liverwurst',
    description: 'Traditional liverwurst',
    base_price: buildYourOwnBasePrice,
    is_featured: false,
    category: ['other'],
    icon: 'bacon'
  },
  {
    id: 17,
    name: 'Bologna',
    description: 'Classic bologna',
    base_price: buildYourOwnBasePrice,
    is_featured: false,
    category: ['beef'],
    icon: 'bacon'
  },
  {
    id: 18,
    name: 'Beef Tongue',
    description: 'Delicatessen beef tongue',
    base_price: buildYourOwnBasePrice,
    is_featured: false,
    category: ['beef'],
    icon: 'drumstick'
  },
  {
    id: 19,
    name: 'Lox',
    description: 'Smoked salmon',
    base_price: buildYourOwnBasePrice,
    is_featured: false,
    category: ['fish'],
    icon: 'fish',
    needs_warning: true
  },
  {
    id: 20,
    name: 'Cheese',
    description: 'Cheese sandwich',
    base_price: 6.99,
    is_featured: false,
    category: ['vegetarian'],
    icon: 'cheese'
  },
  {
    id: 21,
    name: 'Hot Dog',
    description: 'All-beef hot dog',
    base_price: 8.99,
    is_featured: false,
    category: ['grill', 'popular', 'beef'],
    icon: 'hotdog'
  },
  {
    id: 22,
    name: 'Grilled Chicken Breast',
    description: 'Top Quality Grilled Chicken Breast',
    base_price: buildYourOwnBasePrice,
    is_featured: false,
    category: ['grill'],
    icon: 'drumstick'
  },
  {
    id: 23,
    name: 'Seafood Salad',
    description: 'Stars Delicious Seafood Salad',
    base_price: buildYourOwnBasePrice,
    is_featured: false,
    category: ['salads'],
    icon: 'fish'
  },
  {
    id: 24,
    name: 'Smoked Salmon Salad',
    description: 'Stars Delicious Seafood Salad',
    base_price: 15.49,
    is_featured: false,
    category: ['salads', 'fish'],
    icon: 'fish'
  },
  {
    id: 25,
    name: 'Smoked Whitefish Salad',
    description: 'Stars Delicious Seafood Salad',
    base_price: 15.49,
    is_featured: false,
    category: ['salads', 'fish'],
    icon: 'fish'
  }
];

export default meats;
